import { connect } from 'react-redux';
import { guestSelectors } from '@store/guest/selectors';
import { yourJourneySelectors } from '@store/yourJourney';
import { SpaDayV2 } from './SpaDayV2';

const mapStateToProps = (state: any) => ({
  loggedInGuest: guestSelectors.getGuest(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

export const SpaDayV2Connected = connect(mapStateToProps)(SpaDayV2);
